import React from "react";

import PenIcon from "../../icons/pen-icon";
import SaveIcon from "../../icons/save-icon";

const EditButton = ({ setEditMode, editMode }) => {
  const type = !editMode ? "pen" : "add";
  const icon = !editMode ? <PenIcon/> : <SaveIcon/>
  return (
    <button
        onClick={() => setEditMode(!editMode)}
        className={`circle ${type}`}
    >
        {icon}
    </button>
  );
};

export default EditButton;
